<div class="veiculo-item">
      <div class="content">
            <img *ngIf="data.titulo == null" src="/images/produto/sem-foto/capa-veiculo.jpg" [alt]="data.titulo" width="100%" />
            <img *ngIf="data.titulo != null" [src]="data.imagem" [alt]="data.titulo" width="100%" />
      </div>
      <div class="title">
            <h3>{{data.titulo}}</h3>
      </div>
</div>